import { render, staticRenderFns } from "./HeaderForm.vue?vue&type=template&id=38e6a0c6&"
import script from "./HeaderForm.vue?vue&type=script&lang=js&"
export * from "./HeaderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38e6a0c6')) {
      api.createRecord('38e6a0c6', component.options)
    } else {
      api.reload('38e6a0c6', component.options)
    }
    module.hot.accept("./HeaderForm.vue?vue&type=template&id=38e6a0c6&", function () {
      api.rerender('38e6a0c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/gobierto_dashboards/webapp/components/HeaderForm.vue"
export default component.exports